if (import.meta.env.VITE_SENTRY_DSN) {
    import('./Sentry/bootstrap-lazy');
}
